import morphism, { StrictSchema } from 'morphism'

import ClientPassengerInterface from '../../interfaces/client/Passenger'
import ServerPassengerInterface from '../../interfaces/server/Passenger'

import clientPassengerSchema from '../../schemas/client/passenger'

export default (passenger: ServerPassengerInterface) =>
  morphism<StrictSchema<ClientPassengerInterface, ServerPassengerInterface>>(
    clientPassengerSchema,
    passenger
  )
